import moment from 'moment';
import { getOpeningTimes } from '../../api/index';

const OpeningTimes = async () => {
  const contactBlockMessages = document.querySelectorAll('.contact-block__message');

  contactBlockMessages.forEach(async (contactBlockMessage) => {
    const developmentId = contactBlockMessage.dataset.id;
    const timeMessageElement = contactBlockMessage.querySelector('.contact-block__message--opening');
    const svgElement = contactBlockMessage.querySelector('.contact-block__svg');

    getOpeningTimes(developmentId).then((data) => {
      if (data) {
        let openingTimesArr = data.data;
        let today = openingTimesArr.filter((day) => {
          return parseInt(day.opening_times.day.value) == moment().format('d');
        });

        if (moment().isAfter(moment(today[0].opening_times.opens_at, 'hh:mm')) && moment().isAfter(moment(today[0].opening_times.closes_at, 'hh:mm'))) {
          timeMessageElement.classList.add('contact-block__message--closed');
          timeMessageElement.innerHTML = `is <strong>closed</strong>`;
        } else if (moment().isAfter(moment(today[0].opening_times.opens_at, 'hh:mm')) && moment().isBefore(moment(today[0].opening_times.closes_at, 'hh:mm'))) {
          svgElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><circle cx="4" cy="9" r="6" transform="translate(4 -1)" fill="#55A577" stroke="#6DB18A" stroke-width="4" fill-rule="evenodd" stroke-opacity=".2"/></svg>`;
          timeMessageElement.innerHTML = `is <strong>open</strong>`;
        } else if (moment().isBefore(moment(today[0].opening_times.opens_at, 'hh:mm'))) {
          timeMessageElement.classList.add('contact-block__message--closed');
          timeMessageElement.innerHTML = `is closed but will reopen <strong>${moment(today[0].opening_times.opens_at, "HH:mm").format("LT")} ${today[0].opening_times.day.label}</strong>`;
        } else {
          timeMessageElement.classList.add('contact-block__message--closed');
          timeMessageElement.innerHTML = `is closed for the day`;
        }
      }
    });
  });
}

export default OpeningTimes;
